import { toast as sonner } from "sonner";

interface InfoToastOptions {
  action?: { label: string; onClick: () => void };
}

export const toast = {
  success: (message: string) => sonner.success(message),
  error: (message: string) => sonner.error(message),
  info: (message: string, options?: InfoToastOptions) => sonner.info(message, options),
  promise: <T>(p: Promise<T>, opts: { loading: string; success: string; error: string }) =>
    sonner.promise(p, opts),
};
